import * as type from './mutation-types'
export const state = {
    status: -9999,
    errmsg: '',
    userInfo: {},
    loading: '',
    curGearInfo: {},
    cgLoading: '',
    payModeInfo: {},
    pmLoading: '',
    iapInfo: {},
    iapLoading: '',
    orderInfo: {},
    orderLoading: '',
    orderData: {},
    orderStatus: '',
    orderVerifyData: {},
    ovStatus: '',
    reqData: {},
    reqStatus: '',
    dpList: {},
    dpLoading: '',
    cRoleList: {},
    crLoading: '',
    subList: {},
    subLoading: '',
    uname: '',
    pointData: {},
    upLoading: '',
    pointRule: {},
    urLoading: '',
    pointSwitch: {},
    uwLoading: '',
    codeData: {},
    codeStatus: '',
    setEmailData: {},
    seStatus: '',
    pointInit: {},
    piLoading: '',
    pwdFlag: {},
    pfLoading: '',
    emailFlag: {},
    efLoading: '',
    pwdData: {},
    psStatus: '',
    cPwdData: {},
    cpStatus: '',
    peData: {},
    peStatus: '',
    checkData: {},
    checkStatus: '',
    cpeData: {},
    cpeLoading: '',
    versionData: {},
    vLoading: '',
    pcInfoData: {},
    pcInfoLoading: '',
    pccData: {},
    pccLoading: '',
    pcAcData: {},
    pcAcLoading: '',
    pcPmData: {},
    pcPmLoading: '',
    pcgData: {},
    pcgLoading: '',
    allGearData: {},
    allGearLoading: '',
    wRegionData: {},
    wRegionLoading: '',
    wInfoData: {},
    wInfoLoading: '',
    wPayModeData: {},
    wPayModeLoading: '',
    wUnloadData: {},
    wUnloadLoading: '',
    wSwitchData: {},
    wSwitchLoading: '',
    wNtloginData: {},
    wNtloginLoading: '',
    wScanloginData: {},
    wScanloginLoading: '',
    wGeneCodeData: {},
    wGeneCodeLoading: '',
    wGeneInfoData: {},
    wGeneInfoLoading: '',
    wGoodsData: {},
    wGoodsLoading: '',
    wLogoutData: {},
    wLogoutLoading: '',
    wRoleData: {},
    wRoleLoading: '',
    codeLogData: {},
    codeLogLoading: '',
    VKParamsData: {},
    VKPLoading: '',
    VKCodeLoginData: {},
    VKCodeLogLoading: '',
    showPage: false
}
export function getCookiesObj() { 
    return document.cookie.split(';').reduce((f, sv) => {
        let _sv = sv.trim().split('=').map(v => {
            return v.trim()
        })
        f[_sv[0]] = _sv[1]   
        return f  
    }, {})
}
export const mutations = {
    [type.ERROR_RECEIVE](state, res) {},
    [type.INIT](state, res) {
        res.uname && (state.uname = res.uname)
        res.isLogin && (state.isLogin = res.isLogin)
        res.showPage && (state.showPage = res.showPage)
    },

    [type.GETPCGEAR_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.pcgData = {}
        state.pcgLoading = 'loading'
    },

    [type.GETPCGEAR_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.pcgData = (res && res.content) || {}
        state.pcgLoading = state.status > -9999 && 'loaded'
    },

    [type.CHECKPAYEMAIL_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.cpeData = {}
        state.cpeLoading = 'loading'
    },
    [type.CHECKPAYEMAIL_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.cpeData = (res && res.content) || {}
        state.cpeLoading = state.status > -9999 && 'loaded'
    },

    [type.GETUSERPOINTDATA_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.pointData = {}
        state.upLoading = 'loading'
    },
    [type.GETUSERPOINTDATA_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.pointData = (res && res.content) || {}
        state.upLoading = state.status > -9999 && 'loaded'
    },

    [type.GETUSERPOINTRULE_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.pointRule = {}
        state.urLoading = 'loading'
    },
    [type.GETUSERPOINTRULE_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.pointRule = (res && res.content) || {}
        state.urLoading = state.status > -9999 && 'loaded'
    },

    [type.GETUSERPOINTSWITCH_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.pointSwitch = {}
        state.uwLoading = 'loading'
    },
    [type.GETUSERPOINTSWITCH_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.pointSwitch = (res && res.content) || {}
        state.uwLoading = state.status > -9999 && 'loaded'
    },

    [type.ORDERSUBLIST_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.subList = {}
        state.subLoading = 'loading'
    },
    [type.ORDERSUBLIST_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.subList = (res && res.content) || {}
        state.subLoading = state.status > -9999 && 'loaded'
    },

    [type.CHECKROLESTOKEN_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.cRoleList = {}
        state.crLoading = 'loading'
    },
    [type.CHECKROLESTOKEN_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.cRoleList = (res && res.content) || {}
        state.crLoading = state.status > -9999 && 'loaded'
    },

    [type.GETDEFAULTPAYMENT_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.dpList = {}
        state.dpLoading = 'loading'
    },
    [type.GETDEFAULTPAYMENT_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.dpList = (res && res.content) || {}
        state.dpLoading = state.status > -9999 && 'loaded'
    },

    [type.THIRDPAYLOGIN_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.userInfo = {}
        state.loading = 'loading'
    },
    [type.THIRDPAYLOGIN_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.userInfo = (res && res.content) || {}
        state.loading = state.status > -9999 && 'loaded'
    },

    [type.GETCURRENCYGEAR_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.curGearInfo = {}
        state.cgLoading = 'loading'
    },
    [type.GETCURRENCYGEAR_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.curGearInfo = (res && res.content) || {}
        state.cgLoading = state.status > -9999 && 'loaded'
    },

    [type.GETALLPAYMODE_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.payModeInfo = {}
        state.pmLoading = 'loading'
    },
    [type.GETALLPAYMODE_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.payModeInfo = (res && res.content) || {}
        state.pmLoading = state.status > -9999 && 'loaded'
    },

    [type.SERVERIAPLIST_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.iapInfo = {}
        state.iapLoading = 'loading'
    },
    [type.SERVERIAPLIST_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.iapInfo = (res && res.content) || {}
        state.iapLoading = state.status > -9999 && 'loaded'
    },

    [type.GETTHIRDPAYORDERLIST_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.orderInfo = {}
        state.orderLoading = 'loading'
    },
    [type.GETTHIRDPAYORDERLIST_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.orderInfo = (res && res.content) || {}
        state.orderLoading = state.status > -9999 && 'loaded'
    },

    [type.CREATETHIRDPAYORDER_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.orderData = {}
        state.orderStatus = 'stating'
    },
    [type.CREATETHIRDPAYORDER_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.orderData = (res && res.content) || {}
        state.orderStatus = state.status > -9999 && 'stated'
    },

    [type.VERIFYTHIRDPAYORDER_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.orderVerifyData = {}
        state.ovStatus = 'stating'
    },
    [type.VERIFYTHIRDPAYORDER_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.orderVerifyData = (res && res.content) || {}
        state.ovStatus = state.status > -9999 && 'stated'
    },

    [type.THIRDPAYORDERREQUESTPAY_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.reqData = {}
        state.reqStatus = 'stating'
    },
    [type.THIRDPAYORDERREQUESTPAY_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.reqData = (res && res.content) || {}
        state.reqStatus = state.status > -9999 && 'stated'
    },

    [type.GETEMAILCODE_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.codeData = {}
        state.codeStatus = 'stating'
    },
    [type.GETEMAILCODE_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.codeData = (res && res.content) || {}
        state.codeStatus = state.status > -9999 && 'stated'
    },

    [type.SETPAYEMAIL_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.setEmailData = {}
        state.seStatus = 'stating'
    },
    [type.SETPAYEMAIL_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.setEmailData = (res && res.content) || {}
        state.seStatus = state.status > -9999 && 'stated'
    },

    [type.GETPOINTINIT_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.pointInit = {}
        state.piLoading = 'loading'
    },
    [type.GETPOINTINIT_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.pointInit = (res && res.content) || {}
        state.piLoading = state.status > -9999 && 'loaded'
    },

    [type.GETPAYPWDFLAG_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.pwdFlag = {}
        state.pfLoading = 'loading'
    },
    [type.GETPAYPWDFLAG_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.pwdFlag = (res && res.content) || {}
        state.pfLoading = state.status > -9999 && 'loaded'
    },

    [type.GETEMAILFLAG_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.emailFlag = {}
        state.efLoading = 'loading'
    },
    [type.GETEMAILFLAG_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.emailFlag = (res && res.content) || {}
        state.efLoading = state.status > -9999 && 'loaded'
    },

    [type.SETPAYPWD_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.pwdData = {}
        state.psStatus = 'stating'
    },
    [type.SETPAYPWD_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.pwdData = (res && res.content) || {}
        state.psStatus = state.status > -9999 && 'stated'
    },

    [type.CHANGEPAYPWD_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.cPwdData = {}
        state.cpStatus = 'stating'
    },
    [type.CHANGEPAYPWD_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.cPwdData = (res && res.content) || {}
        state.cpStatus = state.status > -9999 && 'stated'
    },

    [type.GETUSERPAYEMAIL_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.peData = {}
        state.peStatus = 'stating'
    },
    [type.GETUSERPAYEMAIL_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.peData = (res && res.content) || {}
        state.peStatus = state.status > -9999 && 'stated'
    },

    [type.CHECKPAYPWD_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.checkData = {}
        state.checkStatus = 'stating'
    },
    [type.CHECKPAYPWD_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.checkData = (res && res.content) || {}
        state.checkStatus = state.status > -9999 && 'stated'
    },

    [type.GETVERSION_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.versionData = {}
        state.vLoading = 'stating'
    },
    [type.GETVERSION_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.versionData = (res && res.content) || {}
        state.vLoading = state.status > -9999 && 'stated'
    },

    [type.GETPCINFO_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.pcInfoData = {}
        state.pcInfoLoading = 'loading'
    },
    [type.GETPCINFO_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.pcInfoData = (res && res.content) || {}
        state.pcInfoLoading = state.status > -9999 && 'loaded'
    },

    [type.GETPCCOUNTRY_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.pccData = {}
        state.pccLoading = 'loading'
    },
    [type.GETPCCOUNTRY_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.pccData = (res && res.content) || {}
        state.pccLoading = state.status > -9999 && 'loaded'
    },

    [type.GETPCALLCOUNTRY_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.pcAcData = {}
        state.pcAcLoading = 'loading'
    },
    [type.GETPCALLCOUNTRY_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.pcAcData = (res && res.content) || {}
        state.pcAcLoading = state.status > -9999 && 'loaded'
    },

    [type.GETPCPAYM_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.pcPmData = {}
        state.pcPmLoading = 'loading'
    },
    [type.GETPCPAYM_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.pcPmData = (res && res.content) || {}
        state.pcPmLoading = state.status > -9999 && 'loaded'
    },

    [type.GETALLGEAR_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.allGearData = {}
        state.allGearLoading = 'loading'
    },
    [type.GETALLGEAR_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.allGearData = (res && res.content) || {}
        state.allGearLoading = state.status > -9999 && 'loaded'
    },

    [type.GETWEBREGION_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.wRegionData = {}
        state.wRegionLoading = 'loading'
    },
    [type.GETWEBREGION_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.wRegionData = (res && res.content) || {}
        state.wRegionLoading = state.status > -9999 && 'loaded'
    },

    [type.GETWEBAPPINFO_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.wInfoData = {}
        state.wInfoLoading = 'loading'
    },
    [type.GETWEBAPPINFO_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.wInfoData = (res && res.content) || {}
        state.wInfoLoading = state.status > -9999 && 'loaded'
    },

    [type.GETWEBPAYMODE_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.wPayModeData = {}
        state.wPayModeLoading = 'loading'
    },
    [type.GETWEBPAYMODE_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.wPayModeData = (res && res.content) || {}
        state.wPayModeLoading = state.status > -9999 && 'loaded'
    },

    [type.GETWEBUNLOADGOODS_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.wUnloadData = {}
        state.wUnloadLoading = 'loading'
    },
    [type.GETWEBUNLOADGOODS_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.wUnloadData = (res && res.content) || {}
        state.wUnloadLoading = state.status > -9999 && 'loaded'
    },

    [type.GETWEBSWITCH_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.wSwitchData = {}
        state.wSwitchLoading = 'loading'
    },
    [type.GETWEBSWITCH_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.wSwitchData = (res && res.content) || {}
        state.wSwitchLoading = state.status > -9999 && 'loaded'
    },

    [type.GETNTLOGIN_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.wNtloginData = {}
        state.wNtloginLoading = 'loading'
    },
    [type.GETNTLOGIN_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.wNtloginData = (res && res.content) || {}
        state.wNtloginLoading = state.status > -9999 && 'loaded'
    },

    [type.GETSCANLOGIN_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.wScanloginData = {}
        state.wScanloginLoading = 'loading'
    },
    [type.GETSCANLOGIN_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.wScanloginData = (res && res.content) || {}
        state.wScanloginLoading = state.status > -9999 && 'loaded'
    },

    [type.GETGENECODE_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.wGeneCodeData = {}
        state.wGeneCodeLoading = 'loading'
    },
    [type.GETGENECODE_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.wGeneCodeData = (res && res.content) || {}
        state.wGeneCodeLoading = state.status > -9999 && 'loaded'
    },

    [type.GETGENEINFO_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.wGeneInfoData = {}
        state.wGeneInfoLoading = 'loading'
    },
    [type.GETGENEINFO_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.wGeneInfoData = (res && res.content) || {}
        state.wGeneInfoLoading = state.status > -9999 && 'loaded'
    },

    [type.GETWEBROLELIST_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.wRoleData = {}
        state.wRoleLoading = 'loading'
    },
    [type.GETWEBROLELIST_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.wRoleData = (res && res.content) || {}
        state.wRoleLoading = state.status > -9999 && 'loaded'
    },

    [type.getMallLoginStatus_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.wGoodsData = {}
        state.wGoodsLoading = 'loading'
    },
    [type.getMallLoginStatus_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.wGoodsData = (res && res.content) || {}
        state.wGoodsLoading = state.status > -9999 && 'loaded'
    },

    [type.GETWEBLOGOUT_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.wLogoutData = {}
        state.wLogoutLoading = 'loading'
    },
    [type.GETWEBLOGOUT_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.wLogoutData = (res && res.content) || {}
        state.wLogoutLoading = state.status > -9999 && 'loaded'
    },

    [type.GETCODELOGIN_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.codeLogData = {}
        state.codeLogLoading = 'loading'
    },
    [type.GETCODELOGIN_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.codeLogData = (res && res.content) || {}
        state.codeLogLoading = state.status > -9999 && 'loaded'
    },

    [type.GETVKPARAMS_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.VKParamsData = {}
        state.VKPLoading = 'loading'
    },
    [type.GETVKPARAMS_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.VKParamsData = (res && res.content) || {}
        state.VKPLoading = state.status > -9999 && 'loaded'
    },

    [type.GETVKCODELOGIN_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.VKCodeLoginData = {}
        state.VKCodeLogLoading = 'loading'
    },
    [type.GETVKCODELOGIN_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.VKCodeLoginData = (res && res.content) || {}
        state.VKCodeLogLoading = state.status > -9999 && 'loaded'
    },
}